(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // RDCTD shelves. The last step is the default: everything stacked in rows.
    // n = products across, rows = rows that scroll together, wrap = no scrolling at all.
    const steps = {
      desktop: [
        { n: 2, rows: 1 },
        { n: 3, rows: 1 },
        { n: 4, rows: 2 },
        { n: 6, rows: 3 },
        { n: 10, wrap: true },
      ],
      phone: [
        { n: 1, rows: 1 },
        { n: 2, rows: 1 },
        { n: 3, rows: 2 },
        { n: 4, rows: 3 },
        { n: 8, wrap: true },
      ],
    };
    const phone = window.matchMedia('(max-width: 749px)');
    const list = () => (phone.matches ? steps.phone : steps.desktop);
    const trackOf = (shelf) => shelf.querySelector('[data-zp-shelf-track]');

    const apply = (shelf) => {
      const track = trackOf(shelf);
      if (!track) return;
      const levels = list();
      const index = Math.min(levels.length - 1, Math.max(0, Number(shelf.dataset.step ?? levels.length - 1)));
      shelf.dataset.step = String(index);
      const level = levels[index];
      track.style.setProperty('--zp-shelf-n', String(level.n));
      track.style.setProperty('--zp-shelf-rows', String(level.rows || 1));
      shelf.toggleAttribute('data-wrap', Boolean(level.wrap));
      shelf.toggleAttribute('data-big', index <= 1);
      shelf.querySelector('[data-zp-shelf-zoom="-1"]').disabled = index >= levels.length - 1;
      shelf.querySelector('[data-zp-shelf-zoom="1"]').disabled = index <= 0;
      arrows(shelf);
    };

    const arrows = (shelf) => {
      const track = trackOf(shelf);
      const back = shelf.querySelector('[data-zp-shelf-step="-1"]');
      const on = shelf.querySelector('[data-zp-shelf-step="1"]');
      if (!track || !back || !on) return;
      back.disabled = track.scrollLeft <= 2;
      on.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };

    document.addEventListener('click', (event) => {
      const zoom = event.target.closest('[data-zp-shelf-zoom]');
      if (zoom) {
        const shelf = zoom.closest('[data-zp-shelf]');
        // − (zoom out) moves toward the stacked wall; + (zoom in) toward one big row.
        shelf.dataset.step = String(Number(shelf.dataset.step) + (Number(zoom.dataset.zpShelfZoom) < 0 ? 1 : -1));
        trackOf(shelf).scrollLeft = 0;
        apply(shelf);
        return;
      }
      const step = event.target.closest('[data-zp-shelf-step]');
      if (step) {
        const track = trackOf(step.closest('[data-zp-shelf]'));
        track.scrollBy({ left: Number(step.dataset.zpShelfStep) * track.clientWidth, behavior: 'smooth' });
      }
    });

    document.addEventListener(
      'scroll',
      (event) => {
        if (event.target instanceof Element && event.target.matches('[data-zp-shelf-track]')) {
          arrows(event.target.closest('[data-zp-shelf]'));
        }
      },
      { capture: true, passive: true }
    );

    const all = () => document.querySelectorAll('[data-zp-shelf]').forEach((shelf) => trackOf(shelf) && apply(shelf));
    // Switching between phone and desktop sizes starts the shelves over, zoomed out.
    phone.addEventListener('change', () => {
      document.querySelectorAll('[data-zp-shelf]').forEach((shelf) => delete shelf.dataset.step);
      all();
    });
    window.addEventListener('resize', () => document.querySelectorAll('[data-zp-shelf]').forEach(arrows));
    all();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zp-home-art"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // JOIN WAITLIST / ENTER CODE: type, press enter or the arrow, and the answer shows in the same box.
    // Sent in the background (no reload). If Shopify asks for a human check (a captcha page), or the
    // network fails, the form is sent the normal way instead.
    // With Klaviyo set up, the waitlist email goes to Klaviyo instead, then (optionally) a phone number.
    document.querySelectorAll('[data-zp-tv-form]').forEach((form) => {
      const box = form.querySelector('[data-zp-tv-box]');
      const input = form.querySelector('.zp-tv__input');
      const status = form.querySelector('[data-zp-tv-status]');
      if (!box || !input || !status) return;
      let label = input.placeholder;
      const setState = (state, text) => {
        if (state) box.dataset.state = state;
        else delete box.dataset.state;
        status.textContent = text || '';
      };

      // While typing, the box says what to type (EMAIL / CODE); empty and unfocused, it shows its label again.
      input.addEventListener('focus', () => {
        if (input.dataset.placeholderTyping) input.placeholder = input.dataset.placeholderTyping;
      });
      input.addEventListener('blur', () => {
        input.placeholder = label;
      });
      input.addEventListener('input', () => {
        if (box.dataset.state === 'error') setState(null);
      });
      // Clicking anywhere on the box (not just the text) puts the cursor in it.
      box.addEventListener('click', (event) => {
        if (!event.target.closest('button, [data-zp-tv-prefix]') && !input.disabled) input.focus();
      });

      // Klaviyo (Theme settings > Klaviyo): the email, then a first name and a phone number if they're
      // asked for (both optional). The steps themselves live in assets/zp-klaviyo.js.
      const useKlaviyo = form.dataset.zpTvForm === 'waitlist' && box.dataset.klaviyoKey && box.dataset.klaviyoList;
      let flow = null;
      const getFlow = () => {
        if (!flow && useKlaviyo && window.zpKlaviyo) {
          flow = window.zpKlaviyo.flow({
            key: box.dataset.klaviyoKey,
            list: box.dataset.klaviyoList,
            source: box.dataset.source,
            askName: 'askName' in box.dataset,
            askPhone: 'askPhone' in box.dataset,
          });
        }
        return flow;
      };
      const panel = document.querySelector('[data-zp-tv-steps]');
      const prompt = panel && panel.querySelector('[data-zp-tv-prompt]');
      const consent = panel && panel.querySelector('[data-zp-tv-consent]');
      const field = form.querySelector(`label[for="${input.id}"]`);
      const prefix = form.querySelector('[data-zp-tv-prefix]');

      const country = () => (prefix ? prefix.value : '+1');

      // Phone numbers format themselves while typed: (720) 555-0199 for +1 numbers.
      const formatNumber = () => {
        if (input.type !== 'tel' || !window.zpKlaviyo) return;
        const atEnd = input.selectionStart === input.value.length;
        input.value = window.zpKlaviyo.formatPhone(input.value, country());
        if (atEnd) input.setSelectionRange(input.value.length, input.value.length);
      };
      input.addEventListener('input', formatNumber);

      // The country code: '+' and up to three digits, sized to fit; empty goes back to +1.
      if (prefix) {
        const sizePrefix = () => {
          prefix.style.width = `${Math.max(2, prefix.value.length)}ch`;
        };
        prefix.addEventListener('input', () => {
          if (window.zpKlaviyo) prefix.value = window.zpKlaviyo.countryCode(prefix.value);
          sizePrefix();
          formatNumber();
          if (box.dataset.state === 'error') setState(null);
        });
        prefix.addEventListener('blur', () => {
          if (!/\d/.test(prefix.value)) prefix.value = '+1';
          sizePrefix();
          formatNumber();
        });
        sizePrefix();
      }

      // Tiny TVs (phones turned sideways) can't fit "PHONE (OPTIONAL)": use the short typing text ("PHONE") there.
      let fit = null;
      const fitLabel = () => {
        if (!fit) return;
        const style = getComputedStyle(input);
        const room = input.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        const context = document.createElement('canvas').getContext('2d');
        context.font = style.font || `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
        const spacing = (parseFloat(style.letterSpacing) || 0) * fit.full.length;
        label = context.measureText(fit.full).width + spacing > room ? fit.short : fit.full;
        input.placeholder = document.activeElement === input ? input.dataset.placeholderTyping : label;
      };

      // The panel hangs right under the box. It takes the TV's text size; on narrow TVs (phones)
      // it's wider than the box, centered on it, so the consent stays readable.
      const place = () => {
        if (!panel || panel.hidden) return;
        const area = panel.parentElement.getBoundingClientRect();
        const anchor = box.getBoundingClientRect();
        const margin = 12;
        const width = anchor.width >= 240 ? anchor.width : Math.min(area.width - 2 * margin, 360);
        const left = Math.max(margin, Math.min(anchor.left - area.left + (anchor.width - width) / 2, area.width - width - margin));
        panel.style.setProperty('--tv-font', getComputedStyle(box).fontSize);
        panel.style.width = `${width}px`;
        panel.style.left = `${left}px`;
        panel.style.top = `${anchor.bottom - area.top + 6}px`;
      };
      window.addEventListener('resize', () => {
        fitLabel();
        place();
      });

      // The box's own label too: on tiny TVs (phones turned sideways) "JOIN WAITLIST" becomes "JOIN".
      // Measured again once the font has loaded.
      if (!box.dataset.state) {
        fit = { full: label, short: label.split(/\s+/)[0] || label };
        fitLabel();
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitLabel);
      }

      const finish = () => {
        fit = null;
        if (prefix) prefix.hidden = true;
        if (panel) panel.hidden = true;
        input.removeAttribute('aria-describedby');
        input.value = '';
        input.disabled = true;
        setState('ok', box.dataset.ok);
      };

      // The same box becomes the name box, then the phone box. On the phone step the question and the
      // text message consent hang under the box; the name step has no panel unless there's a question
      // for it. The arrow on an empty box skips (Nick took SKIP out, 2026-10-06).
      const showStep = (step) => {
        if (step === 'done') {
          finish();
          return;
        }
        const phone = step === 'phone';
        const data = box.dataset;
        setState(null);
        input.value = '';
        input.type = phone ? 'tel' : 'text';
        input.name = phone ? 'phone' : 'first_name';
        input.autocomplete = phone ? 'tel' : 'given-name';
        input.inputMode = phone ? 'tel' : 'text';
        input.setAttribute('autocapitalize', phone ? 'off' : 'words');
        input.required = false;
        if (prefix) prefix.hidden = !phone;
        const full = phone ? data.phoneLabel : data.nameLabel;
        fit = { full, short: full.split(/\s+/)[0] || full };
        input.dataset.placeholderTyping = (phone ? data.phoneTyping : data.nameTyping) || full;
        fitLabel();
        if (field) field.textContent = phone ? data.phoneField : data.nameField;
        if (panel) {
          prompt.textContent = (phone ? panel.dataset.phonePrompt : panel.dataset.namePrompt) || '';
          prompt.hidden = !prompt.textContent;
          if (consent) consent.hidden = !phone;
          panel.hidden = !(prompt.textContent || (phone && consent));
          place();
        }
        if (phone && consent) {
          input.setAttribute('aria-describedby', consent.id);
          // Close the keyboard, so the consent can be read before typing a number.
          input.blur();
        } else {
          input.removeAttribute('aria-describedby');
        }
      };

      const answer = (result) => {
        if (result.ok) showStep(result.step);
        else if (result.error === 'phone') setState('error', box.dataset.phoneError || box.dataset.error);
        else {
          input.value = '';
          setState('error', box.dataset.error);
        }
      };

      form.addEventListener('submit', async (event) => {
        const steps = useKlaviyo ? getFlow() : null;
        const optional = steps && (steps.step === 'name' || steps.step === 'phone');
        if (box.dataset.state === 'busy' || box.dataset.state === 'ok') {
          event.preventDefault();
          return;
        }
        if (!input.value.trim() && !optional) {
          event.preventDefault();
          input.focus();
          return;
        }
        event.preventDefault();
        setState('busy');
        if (steps) {
          try {
            // An empty name or phone box is the same as SKIP.
            answer(await steps.submit(input.value, { country: country() }));
            return;
          } catch (error) {
            // Klaviyo couldn't be reached (offline, or an ad blocker): the email goes to Shopify below.
          }
        }
        try {
          const response = await fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' });
          const landed = new URL(response.url);
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const fallBack = () => {
            setState(null);
            form.submit();
          };

          if (form.dataset.zpTvForm === 'code') {
            // A right code leaves the password page: go straight into the shop.
            if (landed.pathname !== '/password') {
              window.location.href = box.dataset.enter || '/collections/all';
              return;
            }
            // Back on the password page with our code box: wrong code. Anything else is a check page.
            if (!page.querySelector('#ZpTvCode')) {
              fallBack();
              return;
            }
            input.value = '';
            setState('error', box.dataset.error);
            return;
          }

          // Waitlist: read the answer from the page Shopify sends back.
          const answer = page.querySelector('#ZpTvWaitlist [data-zp-tv-box]');
          if (!answer && !landed.search.includes('customer_posted=true')) {
            fallBack();
            return;
          }
          const detail = (answer && answer.dataset.detail) || '';
          // An email that's already on the list counts as signed up.
          const ok = (answer && answer.dataset.state === 'ok') || landed.search.includes('customer_posted=true') || /taken|already/i.test(detail);
          if (ok) {
            input.disabled = true;
            setState('ok', box.dataset.ok);
          } else {
            input.value = '';
            setState('error', box.dataset.error);
          }
        } catch (error) {
          setState(null);
          form.submit();
        }
      });
    });

    // The picture's height follows the screen height, but only when the width changes too (turning the
    // phone): the iPhone keyboard squashing the screen mustn't resize the picture while someone types.
    let screenWidth = 0;
    const lockScreen = () => {
      if (window.innerWidth === screenWidth) return;
      screenWidth = window.innerWidth;
      document.documentElement.style.setProperty('--zp-screen-h', `${window.innerHeight}px`);
    };
    lockScreen();
    window.addEventListener('resize', lockScreen);
    // Turning the phone: some browsers fire these instead of (or before) resize.
    const relock = () => setTimeout(lockScreen, 250);
    window.addEventListener('orientationchange', relock);
    if (window.screen && window.screen.orientation) window.screen.orientation.addEventListener('change', relock);
    window.matchMedia('(orientation: portrait)').addEventListener('change', relock);
    // And when the page's own width changes, whatever caused it.
    if (window.ResizeObserver) new ResizeObserver(lockScreen).observe(document.documentElement);

    // Drop countdown. The setting is a wall-clock time ("2026-11-22 12:30") in the chosen time zone;
    // work out the real moment (daylight saving included), then tick every second.
    const toMoment = (text, zone) => {
      const m = /^\s*(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T]+(\d{1,2}):(\d{2}))?/.exec(text || '');
      if (!m) return null;
      const [y, mo, d, h, mi] = [m[1], m[2], m[3], m[4] || 0, m[5] || 0].map(Number);
      const wall = Date.UTC(y, mo - 1, d, h, mi);
      let moment = wall;
      try {
        const format = new Intl.DateTimeFormat('en-US', {
          timeZone: zone,
          hourCycle: 'h23',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        });
        // Twice, so a guess that lands on the other side of a daylight-saving switch settles.
        for (let i = 0; i < 2; i += 1) {
          const parts = Object.fromEntries(format.formatToParts(new Date(moment)).map((p) => [p.type, p.value]));
          const shown = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour, +parts.minute, +parts.second);
          moment = wall - (shown - moment);
        }
      } catch (error) {}
      return moment;
    };
    const two = (n) => String(n).padStart(2, '0');

    // Seven-segment digits: a top, b top right, c bottom right, d bottom, e bottom left, f top left, g middle.
    const NS = 'http://www.w3.org/2000/svg';
    const bar = (x1, y1, x2, y2) => {
      const h = 1;
      if (y1 === y2) return [[x1, y1], [x1 + h, y1 - h], [x2 - h, y1 - h], [x2, y1], [x2 - h, y1 + h], [x1 + h, y1 + h]];
      return [[x1, y1], [x1 + h, y1 + h], [x1 + h, y2 - h], [x1, y2], [x1 - h, y2 - h], [x1 - h, y1 + h]];
    };
    const SEGMENTS = {
      a: bar(1.7, 1.2, 10.3, 1.2),
      b: bar(10.8, 1.7, 10.8, 9.5),
      c: bar(10.8, 10.5, 10.8, 18.3),
      d: bar(1.7, 18.8, 10.3, 18.8),
      e: bar(1.2, 10.5, 1.2, 18.3),
      f: bar(1.2, 1.7, 1.2, 9.5),
      g: bar(1.7, 10, 10.3, 10),
    };
    const LIT = ['abcdef', 'bc', 'abged', 'abgcd', 'fgbc', 'afgcd', 'afgedc', 'abc', 'abcdefg', 'abcdfg'];
    const makeDigit = () => {
      const svg = document.createElementNS(NS, 'svg');
      svg.setAttribute('viewBox', '0 0 12 20');
      svg.setAttribute('class', 'zp-clock__digit');
      Object.entries(SEGMENTS).forEach(([name, points]) => {
        const seg = document.createElementNS(NS, 'polygon');
        seg.setAttribute('points', points.map((p) => p.join(',')).join(' '));
        seg.setAttribute('class', 'zp-clock__seg');
        seg.dataset.seg = name;
        svg.appendChild(seg);
      });
      return svg;
    };
    const showDigit = (svg, digit) => {
      const lit = LIT[digit] || '';
      svg.querySelectorAll('polygon').forEach((seg) => seg.classList.toggle('zp-clock__seg--on', lit.includes(seg.dataset.seg)));
    };

    document.querySelectorAll('[data-zp-countdown]').forEach((clock) => {
      const target = toMoment(clock.dataset.date, clock.dataset.zone);
      const face = clock.querySelector('[data-zp-countdown-face]');
      const text = clock.querySelector('[data-zp-countdown-text]');
      if (target === null || !face) {
        clock.hidden = true;
        return;
      }
      const labels = (clock.dataset.labels || '').trim().split(/\s+/).filter(Boolean);
      let groups = [];
      // DD : HH : MM : SS, each pair with its label underneath. Days can grow to three digits.
      const build = (dayDigits) => {
        face.textContent = '';
        groups = [dayDigits, 2, 2, 2].map((count, index) => {
          if (index) {
            const colon = document.createElement('span');
            colon.className = 'zp-clock__colon';
            face.appendChild(colon);
          }
          const group = document.createElement('span');
          group.className = 'zp-clock__group';
          const digits = document.createElement('span');
          digits.className = 'zp-clock__digits';
          const svgs = Array.from({ length: count }, () => digits.appendChild(makeDigit()));
          group.appendChild(digits);
          if (labels[index]) {
            const label = document.createElement('span');
            label.className = 'zp-clock__label';
            label.textContent = labels[index];
            group.appendChild(label);
          }
          face.appendChild(group);
          return svgs;
        });
      };
      let timer = null;
      const tick = () => {
        const left = Math.max(0, Math.floor((target - Date.now()) / 1000));
        if (left === 0) {
          clearInterval(timer);
          const done = document.createElement('span');
          done.className = 'zp-clock__done';
          done.textContent = clock.dataset.done || '00:00:00:00';
          face.textContent = '';
          face.appendChild(done);
          if (text) text.textContent = done.textContent;
          return;
        }
        const parts = [Math.floor(left / 86400), Math.floor((left % 86400) / 3600), Math.floor((left % 3600) / 60), left % 60].map(two);
        if (!groups.length || groups[0].length !== parts[0].length) build(parts[0].length);
        parts.forEach((part, index) => [...part].forEach((digit, place) => showDigit(groups[index][place], Number(digit))));
        if (text) text.textContent = parts.join(':');
      };
      tick();
      timer = setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
